<template>
  <div v-loading="loading">
    <el-table :data="tableData" stripe>
      <el-table-column prop="operate" label="操作人"></el-table-column>
      <el-table-column label="操作状态" v-slot="{ row }">{{ statusMap[row.historyStatus] }}</el-table-column>
      <el-table-column prop="insertTime" label="操作时间"></el-table-column>
    </el-table>

    <br>
    <el-pagination
      style="float: right"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import {
  appealStatusMap,
  appealTrackStatusMap,
  appealSubStatusMap
} from '../const'

export default {
  name: 'HistoryTable',
  mixins: [paginationTableMixin],
  props: {
    complaintId: {
      type: Number,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  computed: {
    statusMap() {
      if (this.type === 1) {
        return appealStatusMap
      } else if (this.type === 2) {
        return appealTrackStatusMap
      } else if (this.type === 4) {
        return appealSubStatusMap
      }

      return appealStatusMap
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const { pagination, type, complaintId } = this
        const { list, total } = await complaintService.queryHistory({
          id: complaintId,
          fType: type,
          page: pagination.current - 1,
          size: pagination.size
        })
        this.tableData = list
        this.pagination.total = total
      } catch (error) {
        this.$message.error(error.message)
      }
      this.loading = false
    }
  }
}
</script>
